import { createSelector } from 'reselect';
import TableDefinitions from '../../../../../common/TableDefinitions';
import HandlersMrdDeviceColumns from '../../containers/HandlersMrdDeviceColumns';
import HandlersColumns from '../../containers/HandlersColumns';

export const getIsMrdDeviceListByCountryLoading = (state) => state.listing.MRD_DEVICE_LIST_BY_COUNTRY.isLoading;
export const getMrdDeviceListByCountryData = TableDefinitions.MRD_DEVICE_LIST_BY_COUNTRY.getDataFunction();
export const getMrdDeviceListByCountryColumns = createSelector(getMrdDeviceListByCountryData, HandlersMrdDeviceColumns);

export const getIsHandlersLoading = (state) => state.listing.HANDLERS_BY_MRD_DEVICE.isLoading;
export const getHandlersData = TableDefinitions.HANDLERS_BY_MRD_DEVICE.getDataFunction();
export const getHandlersColumns = createSelector(getHandlersData, HandlersColumns);

export const getMrdDeviceListByCountry = (state) => state.handlers.mrdDevices;
export const getLastRequestStatus = (state) => state.handlers.lastRequestStatus;
export const getSelectedMrd = (state) => state.handlers.selectedMrd;
export const getAllHandlers = (state) => state.handlers.allHandlers;

export const getAllHandlersByMrd = (state) => state.handlers.handlerListByMrd;
export const getIsHandLerListByMrdLoading = (state) => state.handlers.isHandLerListByMrdLoading;

export const getRequestHandlerName = (state) => state.handlers.requestHandlerName;
export const getPersistedHandlerId = (state) => state.handlers.persistedHandlerId;
export const getIsHandlerPersisted = (state) => state.handlers.isHandlerPersisted;
